import { createContext, useContext, useMemo } from 'react';
import { getNormalizedTracker } from 'personalization-lib/utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const UsageTrackerContext = /*#__PURE__*/createContext({
  tracker: null
});
export const UsageTrackerProvider = ({
  children,
  trackerProps
}) => {
  const tracker = useMemo(() => getNormalizedTracker(trackerProps === null || trackerProps === void 0 ? void 0 : trackerProps.tracker), [trackerProps === null || trackerProps === void 0 ? void 0 : trackerProps.tracker]);
  return /*#__PURE__*/_jsx(UsageTrackerContext.Provider, {
    value: Object.assign({}, trackerProps, {
      tracker
    }),
    children: children
  });
};
export const useUsageTrackerContext = () => useContext(UsageTrackerContext);